/**
 * Download_Offer for the ASK AI CSV download feature.
 *
 * The user-visible statement that the table data in an answer is available as
 * a CSV file (Req 2.4). The offer is delivered by the UI rather than written
 * into the answer text by the assistant, which is what keeps this iteration
 * inside `SPBFinnReact`.
 *
 * Presentational and unconditional: one caption, no state, no props, no DOM
 * access, and no role check. Exactly one offer per answer that has at least
 * one table is the caller's concern — `AnswerTableDownloads` renders this
 * component only when detection found a table, which is also what makes an
 * answer with no table render no offer (Req 1.5).
 *
 * The text is a literal. No answer content reaches it, so the offer adds no
 * injection surface.
 */

import React from "react";
import { Typography } from "@mui/material";

/**
 * The download offer shown once above or below an answer's tables (Req 2.4).
 */
const DownloadOffer: React.FC = () => (
  <Typography variant="caption" color="text.secondary" display="block">
    Table data on this answer can be downloaded as a CSV file.
  </Typography>
);

export default DownloadOffer;
